import React from 'react';
import { IconType } from '../../types';

export const ExcelFileIcon = ({ width = 20, height = 20 }: IconType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M65.1716 7H25C23.8954 7 23 7.8954 23 9V87C23 88.1046 23.8954 89 25 89H83C84.1046 89 85 88.1046 85 87V26.8284C85 26.298 84.7893 25.7893 84.4142 25.4142L66.5858 7.5858C66.2107 7.2107 65.702 7 65.1716 7Z"
      fill="white"
      stroke="#979593"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M66 7V25C66 26.1046 66.8954 27 68 27H86"
      stroke="#979593"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M45 61H35V59H45C45.5523 59 46 59.4477 46 60C46 60.5523 45.5523 61 45 61ZM45 55H35V53H45C45.5523 53 46 53.4477 46 54C46 54.5523 45.5523 55 45 55ZM45 49H35V47H45C45.5523 47 46 47.4477 46 48C46 48.5523 45.5523 49 45 49ZM45 43H35V41H45C45.5523 41 46 41.4477 46 42C46 42.5523 45.5523 43 45 43ZM45 67H35V65H45C45.5523 65 46 65.4477 46 66C46 66.5523 45.5523 67 45 67ZM73 61H63C62.4477 61 62 60.5523 62 60C62 59.4477 62.4477 59 63 59H73C73.5523 59 74 59.4477 74 60C74 60.5523 73.5523 61 73 61ZM73 67H63C62.4477 67 62 66.5523 62 66C62 65.4477 62.4477 65 63 65H73C73.5523 65 74 65.4477 74 66C74 66.5523 73.5523 67 73 67ZM73 55H63C62.4477 55 62 54.5523 62 54C62 53.4477 62.4477 53 63 53H73C73.5523 53 74 53.4477 74 54C74 54.5523 73.5523 55 73 55ZM73 49H63C62.4477 49 62 48.5523 62 48C62 47.4477 62.4477 47 63 47H73C73.5523 47 74 47.4477 74 48C74 48.5523 73.5523 49 73 49ZM73 43H63C62.4477 43 62 42.5523 62 42C62 41.4477 62.4477 41 63 41H73C73.5523 41 74 41.4477 74 42C74 42.5523 73.5523 43 73 43ZM59 61H49C48.4477 61 48 60.5523 48 60C48 59.4477 48.4477 59 49 59H59C59.5523 59 60 59.4477 60 60C60 60.5523 59.5523 61 59 61ZM59 67H49C48.4477 67 48 66.5523 48 66C48 65.4477 48.4477 65 49 65H59C59.5523 65 60 65.4477 60 66C60 66.5523 59.5523 67 59 67ZM59 55H49C48.4477 55 48 54.5523 48 54C48 53.4477 48.4477 53 49 53H59C59.5523 53 60 53.4477 60 54C60 54.5523 59.5523 55 59 55ZM59 49H49C48.4477 49 48 48.5523 48 48C48 47.4477 48.4477 47 49 47H59C59.5523 47 60 47.4477 60 48C60 48.5523 59.5523 49 59 49ZM59 43H49C48.4477 43 48 42.5523 48 42C48 41.4477 48.4477 41 49 41H59C59.5523 41 60 41.4477 60 42C60 42.5523 59.5523 43 59 43Z"
      fill="#C8C6C4"
    />
    <path
      d="M14.6 80H59.4C62.4927 80 65 77.6718 65 74.8V33.2C65 30.3282 62.4927 28 59.4 28H14.6C11.5073 28 9 30.3282 9 33.2V74.8C9 77.6718 11.5073 80 14.6 80Z"
      fill="#107C41"
    />
    <path
      d="M21 71L32.5912 54.4537L21.9748 38H30.5181L36.3138 48.5168C36.8464 49.514 37.2124 50.2587 37.4121 50.7493H37.4867C37.8715 49.9518 38.2706 49.1768 38.6869 48.4255L44.8815 38H52.7244L41.8338 54.3625L53 71H44.6562L37.9619 59.4477C37.679 59.0192 37.4121 58.5047 37.1623 57.9056H37.0632C36.9469 58.2746 36.6885 58.7732 36.2894 59.4013L29.3941 71H21Z"
      fill="white"
    />
  </svg>
);
